var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSelected(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  }, /*#__PURE__*/React.createElement("path", {
    d: "M13.5 22H2.958A.957.957 0 0 1 2 21.044V2.956A.957.957 0 0 1 2.958 2h13.417a.957.957 0 0 1 .962.956V7.74M7.74 7h5.738"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.72 6.667a.333.333 0 1 1 0 .666.333.333 0 0 1 0-.666m0 3.432a.333.333 0 1 1 0 .666.333.333 0 0 1 0-.666m10.776 1.325a3.435 3.435 0 0 0-.454-.273l-1.05-.525a1.84 1.84 0 0 0-1.893.148l-1.64 1.172a2.32 2.32 0 0 0-.944 1.557l-.248 1.74M22 21.333l-4.76-7.612"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m13.52 16 4.953-3.034a1.435 1.435 0 1 0-1.5-2.447l-8.97 5.498h0L6.306 18.74l3.2-.277h0l1.828-1.13"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.004 16H12.67c-.736 0-1.333.597-1.333 1.333h0c0 .737.597 1.334 1.333 1.334h2.438L16.67 22"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSelected);
export default __webpack_public_path__ + "static/media/selected.b4d91c0f.svg";
export { ForwardRef as ReactComponent };